export function projectDetailsSlider() {
    let $slider = $('.project-details-hero-slider');
    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        speed: 500,
        prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 7"><path d="M5 3.5 1.667 7 0 5.25 5 0l5 5.25L8.333 7 5 3.5Z"/></svg></button>',
        nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 7"><path d="M5 3.5 1.667 7 0 5.25 5 0l5 5.25L8.333 7 5 3.5Z"/></svg></button>'
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/projectDetailsSlider.js